export enum ApiTypes {
  SEARCH = '/display/api/v2/search',
  CATEGORY = '/display/api/v1/category',
  BRAND = '/display/api/v1/display/brand',
  W_LABEL = '/display/api/label/v1/label',
  SPECIALTY = '/display/api/v1/display/special',
  ALLY = 'display/api/partner/v1/display',
  EXCLUSIVE = '/display/api/v1/exclusive/display',
  PRESHOW = '/display/api/preshow/v1/display',
}
